module.exports = __webpack_public_path__ + "fonts/Pretendard-Light.3711e13.ttf";